@if (visible()) {
<button
  type="button"
  class="theme-toggle"
  [title]="etiqueta"
  [attr.aria-label]="etiqueta"
  [attr.aria-pressed]="!theme.esOscuro()"
  (click)="theme.alternar()"
>
  @if (theme.esOscuro()) {
    <i class="fa fa-sun-o" aria-hidden="true"></i>
  } @else {
    <i class="fa fa-moon-o" aria-hidden="true"></i>
  }
</button>
}
